import { req, get, post } from '@/plugins/axios'
import type { res } from './login'
import { useStore } from 'vuex'
import { useSite2Station } from '@/store'
import {
  CustomerOverviewRespDTO,
  GetCustomerShopDTO
} from './interface/customer'
import { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
const store = useStore()

// 获取账号列表
export const getSubCustomer = (): Promise<res> =>
  get('/customer/getSubCustomerList')

// 添加店铺
interface ASD {
  customerShopPlatform?: number;
  customerShopLogo: string;
  customerShopName: string;
  customerShopUrl: string;
}
export const addShop = (data: ASD): Promise<res> =>
  post('/customer/customer/shop/add', data)

// 是否未绑定
export const isAllShopUnbind = (): Promise<res> =>
  post('/customer/customer/shop/getBaseCustomerAuthStatus')
export const isShopUnbind = (): Promise<res> =>
  post('/customer/customer/shop/getBaseCustomerAuthStatusByShopId')

// 第三方店铺授权
interface TAD {
  code?: string;
  sellingPartnerId?: string;
  url?: string;
  accessToken?: string;
  customerShopId?: string | number;
  thirdShopType?: string | number;
  clientId?: string
  clientSecret?: string
}

export const thirdAuth = (data: TAD): Promise<res> => {
  data.customerShopId = Number(data.customerShopId)
  return post('/api/thirdShopAuth/bind', data)
}

// 第三方店铺解绑
export const thirdUnbind = (data: any): Promise<res> => {
  return post('/api/thirdShopAuth/unBind', data)
}

// 更新店铺
interface USD extends ASD {
  clientId?: string;
  clientSecret?: string;
  customerShopId: string;
}
export const updateShop = (data: USD): Promise<res> =>
  post('/customer/customer/shop/update', data)

// 当前余额
interface WD {
  customerShopId: number;
}
export const getWallet = (data: any): Promise<res> =>
  req('/settlement/wallet/getCustomerWallet', data)

// 店铺列表分页
export const shopList = (data: any): Promise<res> =>
  post('/customer/customer/shop/page', data)

// 开启/关闭自动下单
export const autoOrder = (data: any): Promise<res> =>
  post('/customer/customer/shop/auto/order/switch', data)

// 店铺详情
export const getShopInfo = (data: any): Promise<res> =>
  post('/customer/shop/get', data)

// 一键上新
interface PD {
  productCode?: string;
  purchaseChannel?: string;
  languageCode?: string;
}
export const publishProduct = (data: PD): Promise<res> =>
  post('/api/thirdShopItem/publishToShop', data)

// 获取主账号详情
export const getMainCustomer = (params: any) =>
  get('/customer/getMainCustomerDetail', {
    params
  })

// 获取当前账号另一平台（2b或者2c）的token
export const getTotherToken = (): Promise<res> => post('/customer/changeLogin')

// 获取账户概览
export const getCustomerOverview = (data: any): Promise<res> =>
  post('/customer/getCustomerOverview', data)

// 获取用户消息数量
export const getCustomerMessageNum = (): Promise<res> =>
  get('/customer/notify/get/private/unread/count')

// 获取是否需要弹窗接口
export const getCustomerNeedPopUpWindowByTypeApi = (
  params: any
): Promise<res> => get('/customer/needPopUpWindowByType', { params })

// 已读
export const readPopUpWindowByType = (params: any): Promise<res> =>
  get('/customer/update/popUpWindowByType', { params })

// 获取所有物流的国家
export const getCountryListApi = (params: any): Promise<res> =>
  req('/settlement/intShipConfig/get/forwarder/country', {
    ...params,
    stationCode: useSite2Station()
  })

// 获取所有国家
export const getTotalCountryListApi = (params: any): Promise<res> =>
  get('/customer/getAreaByLevelOnly', { params })

// 获取城市
export const getAreaListApi = (params: any): Promise<res> =>
  get('/customer/getAreaById', { params })

// 通过国家获取货代数据
export const getCountryExpressListApi = (data: any): Promise<res> =>
  post('/settlement/intForwarderConfig/query', data)

// 根据国家拿物流信息
export const throughCountryGetExpressApi = (data: any): Promise<res> =>
  post('/settlement/intShipConfig/list', {
    ...data,
    stationCode: useSite2Station()
  })

// 根据物流拿国家信息
export const getExpressAllCountryListApi = (params: any): Promise<res> =>
  get('/settlement/intShipConfig/get/forwarder/country', {
    params: {
      ...params,
      stationCode: useSite2Station()
    }
  })

/** 获取账户概览-当前店铺 */
export const getWorkbenchUserInfoApi = (
  data: GetCustomerShopDTO
): Promise<res<CustomerOverviewRespDTO>> =>
  post('/customer/getCustomerOverviewOwnerShop', data)

// 工作台获取店铺列表
export const getUserShopListApi = (data: any): Promise<res> =>
  post('/customer/getCustomerOverviewOtherShop', data)

// 当前ip是否能够访问
export const isAllowedAccess = (params: any): Promise<res> =>
  get('/customer/isAllowedAccess', { params })

// 新增扣税账号
export const taxAccountAdd = (data: any): Promise<res> =>
  post('/customer/shopTaxDeductionAccount/add', data)

// 编辑扣税账号
export const taxAccountEdit = (data: any): Promise<res> =>
  post('/customer/shopTaxDeductionAccount/edit', data)

// 删除扣税账号
export const taxAccountRemove = (data: any): Promise<res> =>
  post(`/customer/shopTaxDeductionAccount/removeById/${data.id}`)

// 设置默认扣税账号
export const taxAccountDefault = (data: any): Promise<res> =>
  post(`/customer/shopTaxDeductionAccount/setDefault/${data.id}`)

// 扣税账号列表
export const taxAccountList = (data: any): Promise<res> =>
  post('/customer/shopTaxDeductionAccount/getPage', data)

// 获取默认扣税账号
export const taxAccountDefaultGet = (data: any): Promise<res> =>
  get(`/customer/shopTaxDeductionAccount/getById/${data.id}`)

// 获取默认扣税账号
export const checkTaxWhite = (data: any): Promise<res> =>
  post(`/customer/declaration/whitelist/check/${data.mainCustomerId}`)

// 获取是否选择b2b/d2c
export const getCustomer2AgencySign = (): Promise<res> =>
  get('/customer/getCustomer2AgencySign')

// 更新直采用户跳转代采是否弹框标识
export const updateCustomer2AgencySign = (): Promise<res> =>
  post('/customer/updateCustomer2AgencySign')

// 修改国际物流配置
export const editIntShipConfigApi = (data: any): Promise<res> =>
  post('/api/thirdShopOrder/editIntShipConfig', data)

export interface CA {
  configCode: string;
  level: number;
}
export const getConfigApi = (data: CA): Promise<res> =>
  req('/customer/config/get', data)

export interface SCA {
  configCode: string | ENUM_CONFIG_CODE;
  configName: string;
  configValue: string;
}
export const setConfigApi = (data: SCA): Promise<res> =>
  post('/customer/config/save', data)

//
export const authCafe24 = (data: any) => {
  return post('/api/cafe24/authCafe24', data)
}

export const cancelAuthCafe24 = (data: any) => {
  return post('/api/shopify/cancelShopifyAuth', data)
}

export interface WorkbenchBannerRespDTO {
  /** 跳转链接 */
  dumpUrl?: string;
  /** banner外文名字 */
  foreignName?: string;
  /** 类型，1重要公告，2热门活动，3功能更新 */
  functionType?: number | string;
  id?: string;
  /** 展示banner图片 */
  img?: string;
  /** banner名字 */
  name?: string;
  /** 操作人 */
  operator?: string;
  /** 开始时间 */
  startTime?: string;
  /** 结束时间 */
  endTime?: string;
  /** 站点 */
  stationCode?: string;
  /** 是否生效，1失效，0生效 */
  status?: string;
  /** 系统来源 */
  systemSource?: string;
}

/** 客户端获取工作台banner */
export const WorkbenchBannerApi = (): Promise<
  res<WorkbenchBannerRespDTO[]>
> => {
  return get('/customer/workbenchBanner/get')
}

export const notifyReadApi = (params: any) => {
  return post('/settlement/adjust/order/notify/read', params)
}

/** 心愿清单有新增商品提示弹窗 */
export const wishListTipApi = (): Promise<res<WorkbenchBannerRespDTO[]>> => {
  return get('/goods/productPhotoAlbum/wishlist/canOrder/get')
}

export const getCustomerExchangeRateApi = (data: any): Promise<res> =>
  req('/settlement/exchangeRate/getCustomerExchangeRate', data)

export const getIsChoiceShopApi = (params?: any) => {
  return post('/settlement/allInclude/check/customer', params)
}
// 查询国际物流费收费标准
export const getShipFeeConfig = (params: any) => {
  return get('/settlement/allInclude/shipFeeConfig', { params })
}

// 海外备货灰度开关
export const getGrayOverseasInvApi = () => {
  return get('/wms/base/config/grayOverseasInv')
}

// 手书列表
export const getHandBookListApi = (params?: any) => {
  return post('/customer/guideBook/pageList', params)
}

// 固定一口价白名单
export const getAllIncludePriceJpWhiteListApi = (data: any): Promise<res> =>
  req('/settlement/allInclude/getPriceJpWhiteList', data)
